(() => {
  "use strict";
  if (
    window.ShippingEstimator ||
    !window.CartPurchase ||
    !window.IllegalShippingQuotes
  )
    return;
  const strings = window.IllegalShirts.shipping_strings;
  const cart = window.CartPurchase.controller;
  const nodes = () => [
    ...document.querySelectorAll("[data-shipping-estimator]"),
  ];
  const key = (c) =>
    window.IllegalShippingQuotes.cartContext(c, controller.market);
  let lastCart,
    refreshTimer,
    autoTimer,
    requested = false,
    channel;
  const money = (v, currency) =>
    new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency,
      currencyDisplay: "code",
    }).format(v / 100);
  function render(value) {
    nodes().forEach((node) => {
      const status = node.querySelector("[data-shipping-status]");
      const message =
        strings[value.status.replaceAll("-", "_")] || strings.unavailable;
      if (status.textContent !== message) status.textContent = message;
      node.dataset.quoteState = value.status;
      const list = node.querySelector("[data-shipping-rates]");
      list.replaceChildren();
      const total = node.querySelector("[data-shipping-total]");
      total.hidden = true;
      total.textContent = "";
      if (value.status !== "available") return;
      value.rates.forEach((rate) => {
        const row = document.createElement("li"),
          label = document.createElement("span"),
          price = document.createElement("strong");
        label.textContent = rate.name;
        price.textContent = money(rate.amount, rate.currency);
        row.append(label, price);
        list.append(row);
      });
      const least = Math.min(...value.rates.map((r) => r.amount));
      if (Number.isSafeInteger(value.subtotal + least)) {
        total.textContent = strings.combined.replace(
          "{amount}",
          money(value.subtotal + least, value.currency),
        );
        total.hidden = false;
      }
    });
  }
  const controller = new window.IllegalShippingQuotes.Controller({
    cart,
    fetch: window.fetch.bind(window),
    root:
      window.Shopify?.routes?.root ||
      window.IllegalShirts.routes.cart_url.replace(/cart\/?$/, ""),
    market: nodes()[0]?.dataset.market || "",
    onChange: render,
    onUncertain: () => {
      try {
        channel?.postMessage("quote-uncertain");
      } catch (_) {}
    },
    // Without cross-tab coordination, retain the checkout fallback instead of risking a superseded quote.
    lock: (task) =>
      navigator.locks
        ? navigator.locks.request(
            "illegal-shipping-quote",
            { mode: "exclusive", signal: AbortSignal.timeout(3000) },
            task,
          )
        : Promise.reject(new Error("Quote coordination unavailable")),
  });
  function provinces(node, selected = "") {
    const country = node.querySelector("[data-shipping-country]"),
      province = node.querySelector("[data-shipping-province]");
    let values = [];
    try {
      values = JSON.parse(
        country.selectedOptions[0]?.dataset.provinces || "[]",
      );
    } catch (_) {}
    province.replaceChildren(
      new Option(strings.choose_province, ""),
      ...values.map(([value, label]) => new Option(label, value)),
    );
    province.value = selected;
    node.querySelector("[data-shipping-province-wrap]").hidden = !values.length;
  }
  function read(node) {
    return {
      country: node.querySelector("[data-shipping-country]").value,
      province: node.querySelector("[data-shipping-province]").value,
      zip: node.querySelector("[data-shipping-postal]").value,
    };
  }
  function sync(d, origin) {
    nodes()
      .filter((n) => n !== origin)
      .forEach((n) => {
        n.querySelector("[data-shipping-country]").value = d.country;
        provinces(n, d.province);
        n.querySelector("[data-shipping-postal]").value = d.zip;
      });
  }
  function quote(node) {
    const d = read(node);
    controller.setDestination(d);
    sync(d, node);
    if (
      !node.querySelector("[data-shipping-province-wrap]").hidden &&
      !d.province
    ) {
      controller.emit("invalid-destination");
      return;
    }
    requested = true;
    controller.calculate();
  }
  function init() {
    nodes().forEach((n) => {
      if (n.dataset.shippingReady) return;
      n.dataset.shippingReady = "true";
      const country = n.querySelector("[data-shipping-country]");
      const d = controller.destination || {
        country: n.dataset.country,
        province: "",
        zip: "",
      };
      country.value = d.country;
      provinces(n, d.province);
      n.querySelector("[data-shipping-postal]").value = d.zip;
      n.addEventListener("change", (e) => {
        if (e.target === country) provinces(n);
        const next = read(n);
        controller.setDestination(next);
        sync(next, n);
      });
      n.addEventListener("input", (e) => {
        if (!e.target.matches("[data-shipping-postal]")) return;
        const next = read(n);
        controller.setDestination(next);
        sync(next, n);
      });
      n.querySelector("[data-shipping-calculate]").addEventListener(
        "click",
        () => quote(n),
      );
      n.addEventListener("keydown", (e) => {
        if (e.key === "Enter" && e.target.matches("input,select")) {
          e.preventDefault();
          e.stopPropagation();
          quote(n);
        }
      });
    });
    render(controller.value);
  }
  function schedule() {
    clearTimeout(autoTimer);
    if (
      requested &&
      controller.destination &&
      !cart.state().pending &&
      !cart.state().locked &&
      !cart.state().error
    )
      autoTimer = setTimeout(() => controller.calculate(), 250);
  }
  lastCart = key(cart.cart);
  cart.subscribe((state) => {
    const next = key(state.cart);
    if (next !== lastCart) {
      lastCart = next;
      try {
        channel?.postMessage("cart-changed");
      } catch (_) {}
    }
    if (controller.value.status === "invalidated") schedule();
  });
  try {
    channel = new BroadcastChannel("illegal-cart-changes");
    channel.onmessage = (e) => {
      controller.invalidate();
      if (e.data === "quote-uncertain") {
        controller.uncertain = true;
        controller.emit("unavailable");
      } else refresh();
    };
  } catch (_) {}
  async function refresh() {
    if (
      document.visibilityState === "hidden" ||
      cart.state().pending ||
      cart.state().locked ||
      !requested
    )
      return;
    try {
      const revision = cart.state().revision;
      const fresh = await controller.request("cart.js");
      if (
        !cart.state().pending &&
        !cart.state().locked &&
        cart.state().revision === revision &&
        key(fresh) !== lastCart
      ) {
        controller.invalidate();
        cart.accept(fresh);
      }
      controller.expire();
      if (controller.value.status === "invalidated") schedule();
    } catch (_) {
      controller.invalidate();
      controller.emit("unavailable");
    }
  }
  window.addEventListener("focus", () => {
    controller.invalidate();
    refresh();
  });
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      controller.invalidate();
      refresh();
    }
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      controller.invalidate();
      refresh();
    }
  });
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("DOMContentLoaded", init);
  if (document.readyState !== "loading") init();
  refreshTimer = setInterval(refresh, 30000);
  window.ShippingEstimator = {
    controller,
    refresh,
    destroy() {
      clearInterval(refreshTimer);
      clearTimeout(autoTimer);
      channel?.close();
      controller.destroy();
    },
  };
})();
